import { cartPreviewSchema } from "../schemas";
import {
  makeAnyKeySelector,
  makeCollectionSelector,
  makeAnyKeyCollectionSelector,
  makeFetchStatusSelector,
} from "./collections";

export const DEFAULT_COLLECTION = "index";

export function makeViewAnyKeySelector(key, collection) {
  return makeAnyKeySelector(key, collection, cartPreviewSchema);
}

export function makeCartPreviewsSelector(collection = DEFAULT_COLLECTION) {
  return makeCollectionSelector(collection, cartPreviewSchema);
}

export function makeCartPreviewsAnyKeySelector(key, collection = DEFAULT_COLLECTION) {
  return makeAnyKeyCollectionSelector(key, collection, cartPreviewSchema);
}

export function makeCartPreviewsFetchStatusSelector(collection = DEFAULT_COLLECTION) {
  return makeFetchStatusSelector(collection, cartPreviewSchema);
}
